import { ZAffix } from '@zoryn/components/affix'
import { ZAlert } from '@zoryn/components/alert'
import { ZAutocomplete } from '@zoryn/components/autocomplete'
import { ZAvatar, ZAvatarGroup } from '@zoryn/components/avatar'
import { ZBacktop } from '@zoryn/components/backtop'
import { ZBadge } from '@zoryn/components/badge'
import {
  ZBreadcrumb,
  ZBreadcrumbItem,
} from '@zoryn/components/breadcrumb'
import { ZButton, ZButtonGroup } from '@zoryn/components/button'
import { ZCalendar } from '@zoryn/components/calendar'
import { ZCard } from '@zoryn/components/card'
import { ZCarousel, ZCarouselItem } from '@zoryn/components/carousel'
import { ZCascader } from '@zoryn/components/cascader'
import { ZCascaderPanel } from '@zoryn/components/cascader-panel'
import { ZCheckTag } from '@zoryn/components/check-tag'
import {
  ZCheckbox,
  ZCheckboxButton,
  ZCheckboxGroup,
} from '@zoryn/components/checkbox'
import { ZCol } from '@zoryn/components/col'
import { ZCollapse, ZCollapseItem } from '@zoryn/components/collapse'
import { ZCollapseTransition } from '@zoryn/components/collapse-transition'
import { ZColorPickerPanel } from '@zoryn/components/color-picker-panel'
import { ZColorPicker } from '@zoryn/components/color-picker'
import { ZConfigProvider } from '@zoryn/components/config-provider'
import {
  ZAside,
  ZContainer,
  ZFooter,
  ZHeader,
  ZMain,
} from '@zoryn/components/container'
import { ZDatePicker } from '@zoryn/components/date-picker'
import { ZDatePickerPanel } from '@zoryn/components/date-picker-panel'
import {
  ZDescriptions,
  ZDescriptionsItem,
} from '@zoryn/components/descriptions'
import { ZDialog } from '@zoryn/components/dialog'
import { ZDivider } from '@zoryn/components/divider'
import { ZDrawer } from '@zoryn/components/drawer'
import {
  ZDropdown,
  ZDropdownItem,
  ZDropdownMenu,
} from '@zoryn/components/dropdown'
import { ZEmpty } from '@zoryn/components/empty'
import { ZForm, ZFormItem } from '@zoryn/components/form'
import { ZFormCreate } from '@zoryn/components/form-create'
import { ZFormDesigner } from '@zoryn/components/form-designer'
import { ZIcon } from '@zoryn/components/icon'
import { ZImage } from '@zoryn/components/image'
import { ZImageViewer } from '@zoryn/components/image-viewer'
import { ZInput } from '@zoryn/components/input'
import { ZInputNumber } from '@zoryn/components/input-number'
import { ZInputTable } from '@zoryn/components/input-table'
import { ZInputTag } from '@zoryn/components/input-tag'
import { ZLink } from '@zoryn/components/link'
import {
  ZMenu,
  ZMenuItem,
  ZMenuItemGroup,
  ZSubMenu,
} from '@zoryn/components/menu'
import { ZPageHeader } from '@zoryn/components/page-header'
import { ZPagination } from '@zoryn/components/pagination'
import { ZPopconfirm } from '@zoryn/components/popconfirm'
import { ZPopover } from '@zoryn/components/popover'
import { ZPopper } from '@zoryn/components/popper'
import { ZProgress } from '@zoryn/components/progress'
import {
  ZRadio,
  ZRadioButton,
  ZRadioGroup,
} from '@zoryn/components/radio'
import { ZRate } from '@zoryn/components/rate'
import { ZResult } from '@zoryn/components/result'
import { ZDataSource } from '@zoryn/components/data-source'
import { ZRules } from '@zoryn/components/rules'
import { ZRow } from '@zoryn/components/row'
import { ZScrollbar } from '@zoryn/components/scrollbar'
import {
  ZOption,
  ZOptionGroup,
  ZSelect,
} from '@zoryn/components/select'
import { ZSelectV2 } from '@zoryn/components/select-v2'
import { ZSlider } from '@zoryn/components/slider'
import { ZSpace } from '@zoryn/components/space'
import { ZStatistic } from '@zoryn/components/statistic'
import { ZCountdown } from '@zoryn/components/countdown'
import { ZStep, ZSteps } from '@zoryn/components/steps'
import { ZSwitch } from '@zoryn/components/switch'
import { ZTabPane, ZTabs } from '@zoryn/components/tabs'
import { ZTag } from '@zoryn/components/tag'
import { ZTaskCenter } from '@zoryn/components/task-center'
import { ZMessageCenter } from '@zoryn/components/message-center'
import {
  ZAiChat,
  ZAiKnowledge,
  ZAiShare,
  ZAiSidePanel,
} from '@zoryn/components/ai'
import {
  ZAppDomainMenu,
  ZAppDomainNav,
  ZAppRail,
  ZAppShell,
  ZAppTagsBar,
  ZAppTitleBar,
} from '@zoryn/components/app-shell'
import {
  ZDashboard,
  ZDashboardCard,
  ZDashboardEmpty,
  ZDashboardSection,
} from '@zoryn/components/dashboard'
import { ZText } from '@zoryn/components/text'
import { ZTimePicker } from '@zoryn/components/time-picker'
import { ZTimeSelect } from '@zoryn/components/time-select'
import { ZTimeline, ZTimelineItem } from '@zoryn/components/timeline'
import { ZTooltip } from '@zoryn/components/tooltip'
import { ZTransfer } from '@zoryn/components/transfer'
import { ZTree } from '@zoryn/components/tree'
import { ZTreeSelect } from '@zoryn/components/tree-select'
import { ZTreeV2 } from '@zoryn/components/tree-v2'
import { ZUpload } from '@zoryn/components/upload'
import { ZWatermark } from '@zoryn/components/watermark'
import { ZTour, ZTourStep } from '@zoryn/components/tour'
import { ZAnchor, ZAnchorLink } from '@zoryn/components/anchor'
import { ZSegmented } from '@zoryn/components/segmented'
import { ZMention } from '@zoryn/components/mention'
import { ZSplitter, ZSplitterPanel } from '@zoryn/components/splitter'
import { ZGrid } from '@zoryn/components/grid'
import { ZGridImport } from '@zoryn/components/grid-import'
import { ZGridTree } from '@zoryn/components/grid-tree'
import type { Plugin } from 'vue'

export default [
  ZGrid,
  ZGridImport,
  ZGridTree,
  ZAffix,
  ZAlert,
  ZAutocomplete,
  ZAvatar,
  ZAvatarGroup,
  ZBacktop,
  ZBadge,
  ZBreadcrumb,
  ZBreadcrumbItem,
  ZButton,
  ZButtonGroup,
  ZCalendar,
  ZCard,
  ZCarousel,
  ZCarouselItem,
  ZCascader,
  ZCascaderPanel,
  ZCheckTag,
  ZCheckbox,
  ZCheckboxButton,
  ZCheckboxGroup,
  ZCol,
  ZCollapse,
  ZCollapseItem,
  ZCollapseTransition,
  ZColorPickerPanel,
  ZColorPicker,
  ZConfigProvider,
  ZContainer,
  ZAside,
  ZFooter,
  ZHeader,
  ZMain,
  ZDatePicker,
  ZDatePickerPanel,
  ZDataSource,
  ZDescriptions,
  ZDescriptionsItem,
  ZDialog,
  ZDivider,
  ZDrawer,
  ZDropdown,
  ZDropdownItem,
  ZDropdownMenu,
  ZEmpty,
  ZForm,
  ZFormItem,
  ZFormCreate,
  ZFormDesigner,
  ZIcon,
  ZImage,
  ZImageViewer,
  ZInput,
  ZInputNumber,
  ZInputTable,
  ZInputTag,
  ZLink,
  ZMenu,
  ZMenuItem,
  ZMenuItemGroup,
  ZSubMenu,
  ZPageHeader,
  ZPagination,
  ZPopconfirm,
  ZPopover,
  ZPopper,
  ZProgress,
  ZRadio,
  ZRadioButton,
  ZRadioGroup,
  ZRate,
  ZResult,
  ZRules,
  ZRow,
  ZScrollbar,
  ZSelect,
  ZOption,
  ZOptionGroup,
  ZSelectV2,
  ZSlider,
  ZSpace,
  ZStatistic,
  ZCountdown,
  ZSteps,
  ZStep,
  ZSwitch,
  ZTabs,
  ZTabPane,
  ZTaskCenter,
  ZMessageCenter,
  ZAiChat,
  ZAiKnowledge,
  ZAiShare,
  ZAiSidePanel,
  ZAppShell,
  ZAppTitleBar,
  ZAppRail,
  ZAppTagsBar,
  ZAppDomainNav,
  ZAppDomainMenu,
  ZDashboard,
  ZDashboardSection,
  ZDashboardCard,
  ZDashboardEmpty,
  ZTag,
  ZText,
  ZTimePicker,
  ZTimeSelect,
  ZTimeline,
  ZTimelineItem,
  ZTooltip,
  ZTransfer,
  ZTree,
  ZTreeSelect,
  ZTreeV2,
  ZUpload,
  ZWatermark,
  ZTour,
  ZTourStep,
  ZAnchor,
  ZAnchorLink,
  ZSegmented,
  ZMention,
  ZSplitter,
  ZSplitterPanel,
] as Plugin[]
